import { useSearchParams } from 'react-router-dom';
import { ResetPasswordForm } from '../components/reset-password-form';
import { MarcoDeIngreso, TarjetaDeIngreso, TituloDeIngreso } from '../components/marco-de-ingreso';

export function ResetPasswordPage() {
  // Mi empresa › Invitar: el mismo enlace sirve para entrar por primera vez (`&invitacion=1`).
  const [searchParams] = useSearchParams();
  const invitacion = searchParams.get('invitacion') === '1';
  return (
    <MarcoDeIngreso>
      <TituloDeIngreso
        antes={invitacion ? 'Te damos la bienvenida: crea tu' : 'Crea tu nueva'}
        marca="contraseña"
        subtitulo={
          invitacion
            ? 'Con ella entras a Prixia. Elige una que no uses en otro lado.'
            : 'Elige una que no uses en otro lado.'
        }
      />
      <TarjetaDeIngreso>
        <ResetPasswordForm />
      </TarjetaDeIngreso>
    </MarcoDeIngreso>
  );
}

export default ResetPasswordPage;
